import { render, staticRenderFns } from "./PlcLogo.vue?vue&type=template&id=3044a0d6&scoped=true"
import script from "./PlcLogo.vue?vue&type=script&lang=js"
export * from "./PlcLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044a0d6",
  null
  
)

export default component.exports